import { render, staticRenderFns } from "./Gym.vue?vue&type=template&id=deeaa10c"
import script from "./Gym.vue?vue&type=script&lang=js"
export * from "./Gym.vue?vue&type=script&lang=js"
import style0 from "./Gym.vue?vue&type=style&index=0&id=deeaa10c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports